import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { noop } from "lodash";
import { Trash2Icon } from "lucide-react";
import { bool, func } from "prop-types";

import classes from "./DeleteItemIconButton.module.scss";

const DeleteItemIconButton = ({ onClick = noop, ...props }) => {
  return (
    <NewButton
      classes={classes["delete_item_button"]}
      leftIcon={<Trash2Icon size={16} />}
      data-testid="delete-item-icon-button"
      data-show-on-row-hover={Boolean(props["data-show-on-row-hover"])}
      onClick={onClick}
      variant={NewButtonVariant.red}
      size={NewButtonSize.sm}
    />
  );
};

DeleteItemIconButton.propTypes = {
  "data-show-on-row-hover": bool,
  onClick: func,
};

export default DeleteItemIconButton;
